<template>
<div class="loading-container">
    <div v-if="type=='pendulums'" class="loading-buttons pendulums"><i></i><i></i><i></i><i></i><i></i><div class="text"></div></div>
    <div v-else-if="type=='waves'" class="loading-container"><div class="loading-buttons waves"><i></i><i></i><i></i><i></i><i></i></div></div>
</div>
</template>
<script>
export default {
	name: 'Loading',
	props: {
		type: String,
	},
};
</script>
